<div class="info-window">
  <!-- Popup de Tarefas -->
  <ng-container *ngIf="type==systemModuleEnum.Task">
    <app-task-info [task]="element" class="w-100 position-relative" style="min-height: 120px;"></app-task-info>
  </ng-container>
  <!-- Popup de Tarefas -->

  <!-- Popup de Sinalizações -->
  <ng-container *ngIf="type==systemModuleEnum.SignalingRegister">
    <app-signaling-info [signaling]="element" class="w-100 position-relative"
      style="height: 424px;"></app-signaling-info>
  </ng-container>
  <!-- Popup de Sinalizações -->

  <!-- Popup de Sinalizações de Projeto -->
  <ng-container *ngIf="type==systemModuleEnum.Project">
    <app-project-task-sign-info [projectTaskSign]="element" class="w-100 position-relative"
      style="height: 215px;"></app-project-task-sign-info>
  </ng-container>
  <!-- Popup de Sinalizações de Projeto -->

  <!-- Popup de Veículos  e Equipes -->
  <ng-container *ngIf="type==systemModuleEnum.Team">
    <app-team-vehicle [teamVehicle]="element" class="w-100 position-relative p-2"></app-team-vehicle>
  </ng-container>
  <!-- Popup de Veículos e Equipes -->

</div>
